import { api } from '../axios';
import * as math from 'mathjs';
import Mongo from './Mongo';
import Authentication from './Authentication';
import { ThetaHistoryResponse, ThetaResponse } from 'src/types/Modules/Theta';

const HISTORY_THETA_ENDPOINT = 'history/theta';
const THETA_LAST_ENDPOINT = 'history/theta/last';
const BASE_CUTLINE = 95;

export default class Theta extends Mongo {
  public static async save(payload: Record<string, unknown>) {
    try {
      const loginData = Authentication.loggedUser();
      if (!loginData) return;
      const response = await api.post(HISTORY_THETA_ENDPOINT, {
        ...payload,
        user_email: loginData.user.email,
      });
      return response;
    } catch (error) {
      console.error(error);
    }
  }

  public static async getHistory(payload: Record<string, unknown>) {
    try {
      const loginData = Authentication.loggedUser();
      if (!loginData) return;
      const response = await api.get<ThetaResponse>(HISTORY_THETA_ENDPOINT, {
        params: {
          where: {
            ...payload,
            user_email: loginData.user.email,
          },
          sort: '[("_created", -1)]',
          max_results: 25,
        }
      });
      return response;
    } catch (error) {
      console.error(error);
    }
  }

  public static async last(
    subjects: string[]
  ): Promise<ThetaHistoryResponse | undefined> {
    try {
      const loginData = Authentication.loggedUser();
      if (!loginData) return;
      const response = await api.get(THETA_LAST_ENDPOINT, {
        params: {
          aggregate: {
            $user_email: loginData.user.email,
            $subjects: subjects,
            $origin: 'evaluation',
          },
          sort: '[("_created", -1)]',
        },
      });
      return response as ThetaHistoryResponse;
    } catch (error) {
      console.error(error);
    }
  }
  public static cutline(): number {
    const user = Authentication.loggedUser();
    if (!user) return 0;
    if (!user.contest) return 0;
    const theta_last_person =
      user.contest.m - Math.log(1 / user.contest.pu - 1);
    const percentil = this.cdfNormal(theta_last_person) * 100;
    return percentil > BASE_CUTLINE
      ? BASE_CUTLINE
      : percentil < 5
      ? 5
      : percentil;
  }
  public static cdfNormal(theta: number): number {
    const mean = 0;
    const standardDeviation = 1;
    return (
      (1 - math.erf((mean - theta) / (Math.sqrt(2) * standardDeviation))) / 2
    );
  }
}
